import React, { useState, useEffect } from 'react';
import "./style.scss";
import { Switch, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Pagination } from '@mui/material';
import { BsPencil } from 'react-icons/bs';
import { RiDeleteBin6Line } from 'react-icons/ri';
import ModalBanner from 'component/admin/modal_banner';
import { deleteBanner, getAllBanner, hideBanner, unhideBanner } from 'services/admin/bannerService';
import { PacmanLoader } from 'react-spinners';
import Swal from 'sweetalert2';
import { introspective } from 'services/tokenService';
import { useLocation, useNavigate } from 'react-router-dom';
import { use } from 'react';

const CampaignManagement = () => {
    const token = localStorage.getItem("token");
    const [isLoading, setIsLoading] = useState(false);

    function convertDate(inputDate) {
        const trimmedDate = inputDate.split("+")[0];
        const dateObj = new Date(trimmedDate);
        const day = dateObj.getDate(); 
        const month = dateObj.getMonth() + 1; 
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const navigate = useNavigate();
    const [totalPage, setTotalPage] = useState(1);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
      const [page, setPage] = useState(Number(searchParams.get('page') || 1));

    const [campaigns, setCampaigns] = useState([]);

    const [activeCampaigns, setActiveCampaigns] = useState([]);
    const [modal, setModal] = useState(false);
    const [selectedBanner, setsSlectedBanner] = useState();
    const [refreshFetchBanners, setRefreshFetchBanners] = useState(false); 

    const toggleModal = (banner) => {
        setsSlectedBanner(banner);
        setModal((prev) => !prev);
    };

    const [campaignPermission, setCampaignPermission] = useState(""); // lưu xem có quyền qly sách không
    
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                    setCampaignPermission(response.data.permissions.some(permission => permission.id === 7)); // id 7 là campaign
                }
            } 
            catch (error) {
                console.log("introspective failed:", error);
            } 
        };

        fetchPermissions();

    }, [token]);
    console.log(campaignPermission)

    useEffect(() => {
        const fetchCampaigns = async () => {
            setIsLoading(true);
            try {
                const response = await getAllBanner(token, page - 1);
                setCampaigns(response.data.content);
                setTotalPage(response.data.page.totalPages);
            } 
            catch (error) {
                console.log(error);
            }
            finally {
                setIsLoading(false);
            }
        }
        fetchCampaigns()
    }, [refreshFetchBanners, token, page]);

    const handleHideBanner = async (id) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn tắt trạng thái hoạt động?",
            text: `Xác nhận sẽ tắt trạng thái hoạt động"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await hideBanner(token, id);
                console.log(response.data.message)
                if (response.status === 200) {
                    Swal.fire({
                        title: "Tắt trạng thái hoạt động thành công!",
                        text: `Chiến dịch đã được tắt trạng thái hoạt động.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchBanners((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Tắt trạng thái hoạt động thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("hideBanner", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Tắt trạng thái hoạt động thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
            
        }
    };
    
    const handleUnhideBanner = async (id) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn hiển thị lại trạng thái hoạt động?",
            text: `Xác nhận sẽ hiển thị lại trạng thái hoạt động"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await unhideBanner(token, id);
                if (response.status === 200) {
                    Swal.fire({
                        title: "Hiển thị trạng thái hoạt động thành công!",
                        text: `Chiến dịch đã được hiển thị trạng thái hoạt động.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchBanners((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Hiển thị trạng thái hoạt động thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("unhideBanner", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Hiển thị trạng thái hoạt động thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    };

    const handleDeleteCampaign = async (id) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn xóa chiến dịch này?",
            text: `Xác nhận sẽ xoá chiến dịch"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await deleteBanner(token, id);
                if (response.status === 200) {
                    Swal.fire({
                        title: "Xóa chiến dịch thành công",
                        text: `Chiến dịch đã được xóa.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchBanners((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Xóa chiến dịch thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("deleteBanner", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Xóa chiến dịch thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    };

    const handleChangePage = (event, value) => {
        setPage(value);
        navigate(`/admin/campaign?page=${value}`);
        
    };

    return (
        <div className="CampaignList">
            <div className="card border-0 p-4 mt-5">
                <div className="headCard d-flex">
                    <h5>Quản Lý Chiến Dịch</h5>
                    <Button 
                        className="ms-auto" 
                        onClick={(e) => {
                            if (!campaignPermission) {
                                e.preventDefault();
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Không có quyền',
                                    text: 'Bạn không có quyền thêm chiến dịch',
                                });
                            }
                            else {
                                toggleModal(null);
                            }
                        }}
                    >
                        Thêm Chiến Dịch
                    </Button>
                </div>

                <div className="table-responsive mt-3">
                    <table className="table table-bordered v-align">
                        <thead className="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>HOẠT ĐỘNG</th>
                                <th>TÊN CHIẾN DỊCH</th>
                                <th>ẢNH</th>
                                <th>NGÀY TẠO</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {campaigns.map((campaign, index) => (
                                <tr key={campaign.id}>
                                    <td>{index+1}</td>
                                    <td>
                                        <Switch
                                            checked={campaign.isActive}
                                            onChange={(e) => {
                                                if (!campaignPermission) {
                                                    e.preventDefault();
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: 'Không có quyền',
                                                        text: 'Bạn không có quyền thay đổi trạng thái chiến dịch',
                                                    });
                                                }
                                                else {
                                                    campaign.isActive ? handleHideBanner(campaign.id) : handleUnhideBanner(campaign.id)
                                                }
                                            }}
                                            color="secondary"
                                        />
                                    </td>
                                    <td>{campaign.title}</td>
                                    <td>
                                        <img
                                            src={campaign.image}
                                            alt={`Lỗi hình ảnh`}
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                                marginRight: "10px",
                                            }}
                                        />
                                    </td>
                                    <td>{convertDate(campaign.updatedAt)}</td>
                                    <td>
                                        <div className="actions d-flex align-items-center justify-content-center">
                                            <Button
                                                className="secondary"
                                                color="secondary"
                                                onClick={() => {
                                                    if (!campaignPermission) {
                                                        Swal.fire({
                                                            icon: 'error',
                                                            title: 'Không có quyền',
                                                            text: 'Bạn không có quyền chỉnh sửa chiến dịch',
                                                        });
                                                    }
                                                    else {
                                                        toggleModal(campaign);
                                                    }
                                                }} 
                                            >
                                                <BsPencil />
                                            </Button>
                                            <Button
                                                className="error"
                                                color="error"
                                                onClick={() => {
                                                    if (!campaignPermission) {
                                                        Swal.fire({
                                                            icon: 'error',
                                                            title: 'Không có quyền',
                                                            text: 'Bạn không có quyền xóa chiến dịch', 
                                                        });
                                                    }
                                                    else {
                                                        handleDeleteCampaign(campaign.id);
                                                    }
                                                }}
                                            >
                                                <RiDeleteBin6Line />
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        {modal && (
                            <ModalBanner 
                                banner={selectedBanner}   
                                onClose={(isRefresh = false) => {
                                    setModal(false);
                                    if (isRefresh) {
                                        setRefreshFetchBanners((prev) => !prev);
                                    }
                                }}  
                            />
                        )}
                    </table>
                    <div className="d-flex tableFooter">
                        <Pagination 
                            className="ms-auto" 
                            count={totalPage} 
                            color="secondary"
                            page={page} 
                            onChange={handleChangePage}
                        />
                    </div>
                </div>
            </div>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    );
};

export default CampaignManagement;
